var render = function () {
  var _vm$selection$chargin;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "ml-n4",
    attrs: {
      "loading": _vm.loading,
      "flat": ""
    }
  }, [_vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "card-avatar, article, actions"
    }
  }) : _c('div', [_c('debug', {
    attrs: {
      "debug": _vm.selection
    }
  }), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationCard.address")))]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.selection.address.street))]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.selection.address.zip) + " " + _vm._s(_vm.selection.address.city))])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "12"
    }
  }, [(_vm$selection$chargin = _vm.selection.chargingPointOperator) !== null && _vm$selection$chargin !== void 0 && _vm$selection$chargin.name ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationCard.operator")))]), _c('v-list-item-title', [_vm._v(_vm._s(_vm.selection.chargingPointOperator.name))])], 1)], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationCard.bnetza")))]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.selection.isRegistered ? _vm.$t("components.thg.ThgChargingStationCard.bnetzaPublic") : _vm.$t("components.thg.ThgChargingStationCard.bnetzaNotPublic")))])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationCard.commissioningDate")))]), _c('v-list-item-title', [_vm._v(_vm._s(_vm.commissioningDate))])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationCard.connectionPowerInKwh")))]), _c('v-list-item-title', [_vm._v(_vm._s(_vm.selection.connectionPowerInKwh) + " kWh")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "12"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationCard.chargingPointCount")))]), _c('v-list-item-title', [_vm._v(_vm._s(_vm.selection.chargingPointCount || "1"))])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('thg-charging-station-meter-reading-table', {
    attrs: {
      "meterReadings": _vm.meterReadings,
      "selection": _vm.selection
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }